import "../Scss/dynamicLoader.scss"

class DynamicLoader {
    constructor(target) {
        this.inflight_XHRs = []
        this.loading = [];
        this.evalQueue = [];
        this.loadQueue = [];
        this.target = target;
        this.domParser = new DOMParser();
        this.loadingIndicator = document.createElement('div');
        this.loadingIndicator.className = 'dynamicLoader loading-indicator'
        const inner = document.createElement('span')
        inner.className = 'dynamicLoader-spinner'
        this.loadingIndicator.appendChild(inner)
        this.target.appendChild(this.loadingIndicator)
        //console.log(inner);
    }

    collectTag(tag) {
        if (tag.src || tag.href) {
            this.collectTagForLoad(tag);
        } else {
            this.collectTagForEval(tag);
        }
    }

    collectTagForEval(tag) {
        const origTag = tag.tagName;
        const origAttributes = tag.attributes;
        const origContent = tag.innerHTML;
        tag.parentElement.removeChild(tag);
        this.evalQueue.push({tag: origTag, attributes: origAttributes, content: origContent});
    }

    collectTagForLoad(tag) {
        const origTag = tag.tagName;
        const origAttributes = tag.attributes;
        const origContent = tag.innerHTML;
        tag.parentElement.removeChild(tag);
        this.loadQueue.push({tag: origTag, attributes: origAttributes, content: origContent});
    }

    workQueues() {
        this.workLoadingQueue();
        this.workEvalQueue();
    }

    workLoadingQueue() {
        for (const tagProps of this.loadQueue) {
            this.loading.push(
                new Promise((resolve, reject) => {
                    const element = document.createElement(tagProps.tag);
                    element.addEventListener('load', (e) => {
                        resolve(e);
                    });
                    document.head.appendChild(element);
                    for (const attr of tagProps.attributes) {
                        element[attr.name] = attr.nodeValue;
                    }
                    element.innerHTML = tagProps.content;
                })
            );
        }
        this.loadQueue = [];
    }

    workEvalQueue() {
        Promise.all(this.loading).then(() => {
            for (const tagProps of this.evalQueue) {
                const element = document.createElement(tagProps.tag);
                for (const attr of tagProps.attributes) {
                    element[attr.name] = attr.nodeValue;
                }
                element.innerHTML = tagProps.content;
                this.documentWriteBegin();
                this.target.appendChild(element);
                this.documentWriteEnd();
            }
            this.evalQueue = [];
            const event = new Event('dynamicLoader.evalQueueDone', {
                bubbles: true,
            });
            this.target.dispatchEvent(event)
        });
    }

    onXhrStateChange(xhr) {
        if (xhr.readyState === 4 && xhr.status === 200) {
            const loaded = this.domParser.parseFromString(xhr.responseText, 'text/html');
            for (const tag of loaded.querySelectorAll('script')) {
                this.collectTag(tag);
            }
            for (const tag of loaded.querySelectorAll('link[rel="stylesheet"]')) {
                this.collectTag(tag);
            }
            for (const node of loaded.head.childNodes) {
                this.target.appendChild(node);
            }
            for (const node of loaded.body.childNodes) {
                if (node.nodeName === '#text' && node.nodeValue.trim() === "") {
                    continue;
                }
                this.target.appendChild(node);
            }
            this.workQueues();
            this.loadingIndicator.className += ' hidden'
        }
        const index = this.inflight_XHRs.findIndex(e => e === xhr)
        this.inflight_XHRs[index] = null
        if (this.inflight_XHRs.every(e => e == null)) {
            const event = new Event('dynamicLoader.allRequestsDone', {
                bubbles: true,
            });
            this.target.dispatchEvent(event)
        }
    }

    load(endpoint) {
        const xhr = new XMLHttpRequest();
        xhr.withCredentials = true;
        xhr.onreadystatechange = () => this.onXhrStateChange(xhr);
        endpoint += window.location.search.replace('?','&');
        xhr.open("GET", endpoint, true);
        xhr.setRequestHeader('Content-type', 'text/html');
        if (this.target.dataset.authorization) {
            xhr.setRequestHeader('AuthorizationApp', this.target.dataset.authorization);
        }
        this.inflight_XHRs.push(xhr)
        xhr.send();
    }

    documentWriteBegin() {
        this.writeBuffer = "";
        this.origWrite = document.write;
        document.write = (content) => this.documentWrite(content);
    }
    documentWrite(content) {
        this.writeBuffer += content;
    }
    documentWriteEnd() {
        if (this.writeBuffer) {
            const containmentDocument = this.domParser.parseFromString(this.writeBuffer, 'text/html');
            for (const e of containmentDocument.head.childNodes) {
                document.head.appendChild(e);
            }
            for (const e of containmentDocument.body.childNodes) {
                document.body.appendChild(e);
            }
            this.writeBuffer = "";
        }
        document.write = this.origWrite;
    }
}

export function dynamicLoader(target, endpoint) {
    const loader = new DynamicLoader(target);
    loader.load(endpoint);
}
window.dynamicLoader = dynamicLoader;

export default dynamicLoader;
